import React from "react";
import { connect } from "react-redux";
import { Button, ButtonGroup, Col, FormGroup, Input, Row } from "reactstrap";
import BaseInput from "../../../toolkit/baseInput";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import {
  ModalProps,
  serviceCaller,
  ServiceCallerProps,
  withLoginRedirect,
  withModals,
} from "../../composition";
import IUser from "../../../types/services/IUser";
import {
  accountNumberExists,
  createDonor,
  deactivateDonor,
  searchDonorByIdExtended,
  searchUsersById,
  updateDonor,
  subscribeEmailNotification,
  unsubscribeEmailNotification,
  subscribeSmsNotification,
  unsubscribeSmsNotification,
} from "../../../utils/fetch";
import {
  isCurrentUserAdmin,
  isCurrentUserCollaborator,
  isCurrentUserOnlyCollaborator,
} from "../../../utils/roleCheck";
import * as commonActions from "../../../utils/actions/common";
import classNames from "classnames";
import emailValidator from "email-validator";
import phone from "phone";
import Reform from "@franleplant/reform";
import ModalFrame from "../../../toolkit/modalFrame";
import { getParsedDate } from "../../../utils/helpers";
import ReactTooltip from "react-tooltip";

import isEmpty from "lodash.isempty";

interface Props extends ServiceCallerProps, ModalProps {
  userId: string;
  refreshDashboard: () => void;
  hideSelection: () => void;
}

interface State {
  postId?: string;
  mediaKey?: string;
  isCompany: boolean;
  existingDonor: IUser;
  fields: {
    firstName: string;
    lastName: string;
    company: string;
    email: string;
    accountNumber: string;
    phoneNumber: string;
  };
  allNotifications: boolean;
  smsNotification: boolean;
  emailNotification: boolean;
  unsubscribeAll: boolean;
  smsUnsubscribed: boolean;
  emailUnsubscribed: boolean;
  originalEmailUnsubscribed: boolean;
  originalSmsUnsubscribed: boolean;

  errors: any;
  formValid: boolean;
  busyLoading: "save" | "deactivate" | null;

  deactivateDonor: boolean;
  deactivateDonorModalOpen: boolean;
  deactivatedComment: string;
  donorDeactivatedByUser: string;
}

class CreateDonor extends React.PureComponent<Props, State> {
  re = Reform.reactMixins.objectMixin(this);

  private donorLookupInFlight = false;

  state = {
    isCompany: false,
    deactivateDonor: false,
    deactivateDonorModalOpen: false,
    fields: {
      firstName: "",
      lastName: "",
      company: "",
      email: "",
      accountNumber: "",
      phoneNumber: "",
    },
    existingDonor: null as IUser,
    allNotifications: true,
    smsNotification: true,
    emailNotification: true,
    unsubscribeAll: false,
    smsUnsubscribed: false,
    emailUnsubscribed: false,
    originalEmailUnsubscribed: false,
    originalSmsUnsubscribed: false,
    errors: {},
    formValid: false,
    busyLoading: null,
    deactivatedComment: "",
    donorDeactivatedByUser: "",
  };

  validationRules = {
    firstName: {
      check: () => {
        return false;
      },
    },
    lastName: {
      check: () => {
        return false;
      },
    },
    company: {
      check: val => {
        if (this.state.isCompany) {
          return !(val && val !== "");
        }
        return false;
      },
    },
    email: {
      email: val => {
        if (
          this.state.fields.phoneNumber &&
          this.state.fields.phoneNumber !== "" &&
          (val === "" || val === null || typeof val === "undefined")
        ) {
          return false;
        }
        return !emailValidator.validate(val);
      },
    },
    phoneNumber: {
      phoneNumber: val => {
        if (
          this.state.fields.email &&
          this.state.fields.email !== "" &&
          (val === "" || val === null || typeof val === "undefined")
        ) {
          return false;
        }
        return !phone(val).isValid;
      },
    },
  };

  validationMessages = {
    required: () => `Required`,
    email: () => "Please, enter a valid email",
    phoneNumber: () => " Please, enter a valid mobile",
    check: () => `Required`,
    maxLength: ruleValue => `Must be less than ${ruleValue} characters long`,
    default: () => `Invalid`,
  };

  uppercaseFirstLetter = text => {
    return text.charAt(0).toUpperCase() + text.substr(1);
  };

  onChangeData = fieldName => {
    return event => {
      let value = event.target.value;
      this.setState(state => {
        return {
          ...state,
          error: {},
          fields: {
            ...state.fields,
            [fieldName]: value,
          },
        };
      });
    };
  };

  onValidation = fieldName => {
    return event => {
      let value = event.target.value;
      if (
        fieldName === "firstName" ||
        fieldName === "lastName" ||
        fieldName === "company"
      ) {
        value = this.uppercaseFirstLetter(value);
      }
      if (fieldName === "email") {
        value = value.toLowerCase();
      }
      this.setState(
        state => {
          const fields = {
            ...state.fields,
            [fieldName]: value,
          };
          return { ...state, error: {}, fields };
        },
        () =>
          this.setState({
            formValid: this.re.formIsValid(),
          })
      );
    };
  };

  includeDeactivatedReason = (event): void => {
    this.setState({
      deactivatedComment: event.target.value,
    });
  };

  closeDeactivateModal = () => {
    this.setState({
      deactivateDonorModalOpen: false,
    });
  };

  deactivateUserHandler = () => {
    this.setState({
      busyLoading: "deactivate",
    });

    const { existingDonor } = this.state;
    const deactivatedDonor = existingDonor && !existingDonor.deactivated;
    let request = {};

    if (deactivatedDonor) {
      request = {
        deactivatedComment: this.state.deactivatedComment,
        deactivate: true,
        donorId: this.state.existingDonor.id,
      };
    } else {
      request = {
        donorId: this.state.existingDonor.id,
        deactivate: false,
      };
    }

    deactivateDonor(
      this.props.config.adminServiceUrl,
      this.props.currentCharity.id,
      request,
      this.props.serviceAccessToken
    )
      .then(() => {
        setTimeout(() => {
          this.props.navigate(-1);
        }, 2000);
      })
      .catch(() => {
        this.setState(
          {
            busyLoading: null,
          },
          () => {
            alert(
              "There was an error while trying to activate/deactivate this contact, try again later."
            );
          }
        );
      });
  };

  componentDidMount() {
    this.props.hideSelection();
    if (window) {
      window.scrollTo(0, 0);
    }
    this.checkAndFillDonor();
  }

  componentDidUpdate(prevProps) {
    if (!this.state.existingDonor) {
      this.checkAndFillDonor();
    }
    if (
      prevProps.currentCharity &&
      prevProps.currentCharity.id !== this.props.currentCharity.id
    ) {
      this.props.navigate("/contacts");
    }
  }

  checkAndFillDonor = () => {
    if (
      !(
        this.props.config &&
        this.props.params.donorId &&
        this.props.currentCharity &&
        this.props.serviceAccessToken
      )
    ) {
      return;
    }

    if (this.donorLookupInFlight) {
      return;
    }

    this.donorLookupInFlight = true;

    searchDonorByIdExtended(
      this.props.config.searchServiceUrl,
      this.props.currentCharity.id,
      this.props.params.donorId,
      this.props.serviceAccessToken
    )
      .then(response => {
        this.donorLookupInFlight = false;
        if (response) {
          this.setState(
            {
              existingDonor: response,
            },
            () => {
              this.fillDonorValues();
            }
          );
        } else {
          this.props.navigate("/contacts");
        }
      })
      .catch(() => {
        this.donorLookupInFlight = false;
        this.props.navigate("/contacts");
      });
  };

  fillDonorValues = () => {
    const { existingDonor } = this.state;
    const emailUnsubscribed = Boolean(
      existingDonor && existingDonor.emailUnsubscribed
    );
    const smsUnsubscribed = Boolean(
      existingDonor && existingDonor.smsUnsubscribed
    );

    this.setState({
      fields: {
        firstName: existingDonor.firstName ? existingDonor.firstName : "",
        lastName: existingDonor.lastName ? existingDonor.lastName : "",
        company: existingDonor.company ? existingDonor.company : "",
        accountNumber: existingDonor.accountNumber
          ? existingDonor.accountNumber
          : "",
        email: existingDonor.email ? existingDonor.email : "",
        phoneNumber: existingDonor.phoneNumber ? existingDonor.phoneNumber : "",
      },
      emailNotification: existingDonor.notifications
        ? !!existingDonor.notifications.email
        : false,
      smsNotification: existingDonor.notifications
        ? !!existingDonor.notifications.sms
        : false,
      allNotifications: existingDonor.notifications
        ? !!existingDonor.notifications.email &&
          !!existingDonor.notifications.sms
        : false,
      isCompany: !!existingDonor.company,
      deactivateDonor: existingDonor.deactivated,
      emailUnsubscribed: emailUnsubscribed,
      originalEmailUnsubscribed: emailUnsubscribed,
      smsUnsubscribed: smsUnsubscribed,
      originalSmsUnsubscribed: smsUnsubscribed,
      unsubscribeAll: emailUnsubscribed && smsUnsubscribed,
      donorDeactivatedByUser:
        existingDonor.deactivatedBy === "auto"
          ? "Automatically Deactivated"
          : "",
    });
  };

  unsubscribeSection = () => {
    const { existingDonor } = this.state;
    let result = {};

    if (
      this.state.emailUnsubscribed &&
      this.state.emailUnsubscribed !== existingDonor.emailUnsubscribed
    ) {
      result = {
        ...result,
        emailUnsubscribed: this.state.emailUnsubscribed,
      };
    }

    if (
      this.state.smsUnsubscribed &&
      this.state.smsUnsubscribed !== existingDonor.smsUnsubscribed
    ) {
      result = {
        ...result,
        smsUnsubscribed: this.state.smsUnsubscribed,
      };
    }

    return result;
  };

  recalculateAllNotification = () => {
    this.setState({
      allNotifications:
        this.state.smsNotification && this.state.emailNotification,
    });
  };

  recalculateUnsubscribeAll = () => {
    this.setState({
      unsubscribeAll:
        this.state.smsUnsubscribed && this.state.emailUnsubscribed,
    });
  };

  allNotificationsChanged = event => {
    const checked = event.target.checked;
    this.setState({
      allNotifications: checked,
      smsNotification: checked,
      emailNotification: checked,
    });
    if (checked) {
      this.setState({
        unsubscribeAll: false,
        emailUnsubscribed: false,
        smsUnsubscribed: false,
      });
    }
  };

  allUnsubscribeChanged = event => {
    const checked = event.target.checked;

    this.setState({
      unsubscribeAll: checked,
      emailUnsubscribed: checked,
      smsUnsubscribed: checked,
      allNotifications: !checked,
      smsNotification: !checked,
      emailNotification: !checked,
    });
  };

  smsNotificationChanged = event => {
    this.setState(
      {
        smsNotification: event.target.checked,
        smsUnsubscribed: false,
      },
      () => {
        this.recalculateUnsubscribeAll();
        this.recalculateAllNotification();
      }
    );
  };

  smsUnsubscribedNotificationChanged = event => {
    const checked = event.target.checked;
    this.setState(
      {
        smsUnsubscribed: checked,
        smsNotification: !checked,
      },
      () => {
        this.recalculateUnsubscribeAll();
        this.recalculateAllNotification();
      }
    );
  };

  emailUnsubscribedNotificationChanged = event => {
    const checked = event.target.checked;
    this.setState(
      {
        emailUnsubscribed: checked,
        emailNotification: !checked,
      },
      () => {
        this.recalculateUnsubscribeAll();
        this.recalculateAllNotification();
      }
    );
  };

  emailNotificationChanged = event => {
    this.setState(
      {
        emailNotification: event.target.checked,
        emailUnsubscribed: false,
      },
      () => {
        this.recalculateUnsubscribeAll();
        this.recalculateAllNotification();
      }
    );
  };

  formFirstCheck() {
    let validForm = true;
    if (
      this.state.isCompany &&
      (this.state.fields.company === null || this.state.fields.company === "")
    ) {
      validForm = false;
    }

    if (
      (this.state.fields.email === null || this.state.fields.email === "") &&
      (this.state.fields.phoneNumber === null ||
        this.state.fields.phoneNumber === "")
    ) {
      validForm = false;
    }
    return validForm;
  }

  createEditDonor = (isNewDonor: boolean) => {
    const save = () => {
      this.setState(
        {
          busyLoading: "save",
        },
        () => {
          const isValid = this.re.validateFormFromState();
          if (
            isValid &&
            ((this.state.fields.email && this.state.fields.email !== "") ||
              (this.state.fields.phoneNumber &&
                this.state.fields.phoneNumber !== ""))
          ) {
            const unsubscribeSection = this.unsubscribeSection();

            if (isNewDonor) {
              createDonor(
                this.props.config.adminServiceUrl,
                this.props.currentCharity.id,
                {
                  firstName:
                    this.state.fields.firstName == ""
                      ? null
                      : this.state.fields.firstName,
                  lastName:
                    this.state.fields.lastName == ""
                      ? null
                      : this.state.fields.lastName,
                  accountNumber:
                    this.state.fields.accountNumber &&
                    this.state.fields.accountNumber !== ""
                      ? this.state.fields.accountNumber
                      : null,
                  email:
                    this.state.fields.email && this.state.fields.email !== ""
                      ? this.state.fields.email
                      : null,
                  phoneNumber:
                    this.state.fields.phoneNumber &&
                    this.state.fields.phoneNumber !== ""
                      ? phone(this.state.fields.phoneNumber).phoneNumber
                      : null,
                  company: !this.state.isCompany
                    ? null
                    : this.state.fields.company,
                  notifications: {
                    sms: this.state.smsNotification,
                    email: this.state.emailNotification,
                    push: false,
                  },
                  ...unsubscribeSection,
                },
                this.props.serviceAccessToken
              )
                .then(() => {
                  setTimeout(() => {
                    this.setState(
                      {
                        busyLoading: null,
                      },
                      () => {
                        this.props.refreshDashboard();
                        this.props.navigate("/contacts");
                      }
                    );
                  }, 3000);
                })
                .catch(() => {
                  this.setState(
                    {
                      busyLoading: null,
                    },
                    () => {
                      alert(
                        "There was an error while trying to create this donor, try again later."
                      );
                    }
                  );
                });
            } else {
              updateDonor(
                this.props.config.adminServiceUrl,
                this.props.currentCharity.id,
                {
                  id: this.props.params.donorId
                    ? this.props.params.donorId
                    : undefined,
                  firstName: this.state.fields.firstName,
                  lastName: this.state.fields.lastName,
                  accountNumber:
                    this.state.fields.accountNumber &&
                    this.state.fields.accountNumber !== ""
                      ? this.state.fields.accountNumber
                      : null,
                  email:
                    this.state.fields.email && this.state.fields.email !== ""
                      ? this.state.fields.email
                      : null,
                  phoneNumber:
                    this.state.fields.phoneNumber &&
                    this.state.fields.phoneNumber !== ""
                      ? phone(this.state.fields.phoneNumber).phoneNumber
                      : null,
                  company: !this.state.isCompany
                    ? null
                    : this.state.fields.company,
                  notifications: {
                    sms: this.state.smsNotification,
                    email: this.state.emailNotification,
                    push: false,
                  },
                  ...unsubscribeSection,
                },
                this.props.serviceAccessToken
              )
                .then(() => {
                  // Handle email subscription changes via notification service
                  const emailChanged =
                    this.state.emailUnsubscribed !==
                    this.state.originalEmailUnsubscribed;
                  const hasValidEmail =
                    this.state.fields.email && this.state.fields.email !== "";
                  const donorId = this.props.params.donorId;

                  if (
                    emailChanged &&
                    hasValidEmail &&
                    donorId &&
                    this.props.config.notificationServiceUrl
                  ) {
                    const emailSubscriptionPromise = this.state
                      .emailUnsubscribed
                      ? unsubscribeEmailNotification(
                          this.props.config.notificationServiceUrl,
                          this.props.currentCharity.id,
                          donorId,
                          this.state.fields.email,
                          this.props.serviceAccessToken
                        )
                      : subscribeEmailNotification(
                          this.props.config.notificationServiceUrl,
                          this.props.currentCharity.id,
                          donorId,
                          this.state.fields.email,
                          this.props.serviceAccessToken
                        );

                    emailSubscriptionPromise.catch(error => {
                      console.error(
                        "Error updating email subscription status:",
                        error
                      );
                    });
                  }

                  // Handle SMS subscription changes via notification service
                  const smsChanged =
                    this.state.smsUnsubscribed !==
                    this.state.originalSmsUnsubscribed;
                  const hasValidPhone =
                    this.state.fields.phoneNumber &&
                    this.state.fields.phoneNumber !== "";
                  const formattedPhone = hasValidPhone
                    ? phone(this.state.fields.phoneNumber).phoneNumber
                    : null;

                  if (
                    smsChanged &&
                    hasValidPhone &&
                    formattedPhone &&
                    donorId &&
                    this.props.config.notificationServiceUrl
                  ) {
                    const smsSubscriptionPromise = this.state.smsUnsubscribed
                      ? unsubscribeSmsNotification(
                          this.props.config.notificationServiceUrl,
                          this.props.currentCharity.id,
                          donorId,
                          formattedPhone,
                          this.props.serviceAccessToken
                        )
                      : subscribeSmsNotification(
                          this.props.config.notificationServiceUrl,
                          this.props.currentCharity.id,
                          donorId,
                          this.props.serviceAccessToken
                        );

                    smsSubscriptionPromise.catch(error => {
                      console.error(
                        "Error updating SMS subscription status:",
                        error
                      );
                    });
                  }

                  setTimeout(() => {
                    this.setState(
                      {
                        busyLoading: null,
                      },
                      () => {
                        this.props.refreshDashboard();
                        this.props.navigate("/contacts");
                      }
                    );
                  }, 3000);
                })
                .catch(() => {
                  this.setState(
                    {
                      busyLoading: null,
                    },
                    () => {
                      alert(
                        "There was an error while trying to edit this donor, try again later."
                      );
                    }
                  );
                });
            }
          } else if (
            !(
              (this.state.fields.email && this.state.fields.email !== "") ||
              (this.state.fields.phoneNumber &&
                this.state.fields.phoneNumber !== "")
            )
          ) {
            this.setState(
              {
                busyLoading: null,
              },
              () => {
                alert("The donor must have either a mobile number or email");
              }
            );
          } else {
            console.error("Form not valid!!!");
            this.setState({
              busyLoading: null,
            });
          }
        }
      );
    };
    this.setState(
      {
        busyLoading: "save",
      },
      () => {
        if (
          (isNewDonor &&
            this.state.fields.accountNumber &&
            this.state.fields.accountNumber !== "") ||
          (!isNewDonor &&
            this.state.fields.accountNumber &&
            this.state.fields.accountNumber !== "" &&
            this.state.fields.accountNumber !==
              this.state.existingDonor.accountNumber)
        ) {
          accountNumberExists(
            this.props.config.adminServiceUrl,
            this.props.currentCharity.id,
            this.state.fields.accountNumber,
            this.props.serviceAccessToken
          )
            .then(result => {
              if (!result) {
                save();
              } else {
                this.setState(
                  {
                    busyLoading: null,
                  },
                  () => {
                    alert("Account number must be unique");
                  }
                );
              }
            })
            .catch(() => {
              this.setState(
                {
                  busyLoading: null,
                },
                () => {
                  alert(
                    "There was an error while trying to create this donor, try again later."
                  );
                }
              );
            });
        } else {
          save();
        }
      }
    );
  };

  confirmUpdateDonor() {
    if (window.confirm("Are you sure you want to edit this contact?")) {
      this.setState(
        {
          busyLoading: "save",
        },
        () => {
          this.createEditDonor(false);
        }
      );
    }
  }

  renderDeactivatedModal = (): JSX.Element => {
    const { deactivateDonor } = this.state;
    const actionLabel = deactivateDonor ? "activate" : "deactivate";

    return (
      <ModalFrame
        title={"CONFIRMATION"}
        isOpen={this.state.deactivateDonorModalOpen}
        size="xl"
        className={s["modal-xl"]}
        toggle={this.closeDeactivateModal}
      >
        <label className={s.modalSubtitle}>
          {"Are you sure that you want to " + actionLabel + " this contact?"}
        </label>
        {!deactivateDonor && (
          <Input
            className={s.modalTextArea}
            type="textarea"
            name="content"
            id="content"
            value={this.state.deactivatedComment}
            placeholder="Add reason here"
            rows={3}
            onChange={this.includeDeactivatedReason}
          />
        )}
        <Row className={s.modalButton}>
          <Button onClick={this.deactivateUserHandler} className={s.button}>
            {this.state.busyLoading === "deactivate" ? (
              <i className="fa fa-spinner fa-spin">&nbsp;</i>
            ) : (
              actionLabel.toLocaleUpperCase()
            )}
          </Button>
        </Row>
      </ModalFrame>
    );
  };

  renderUnsubscribedLabel = (
    channel: "sms" | "email",
    isUnsubscribed: boolean
  ): JSX.Element | null => {
    if (!isUnsubscribed) {
      return null;
    }
    const timestamp =
      channel === "sms"
        ? this.state.existingDonor?.smsUnsubscribedOn
        : this.state.existingDonor?.emailUnsubscribedOn;
    const dateLabel = timestamp
      ? new Date(timestamp).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
      : "";
    const tooltipId = `create-donor-unsubscribed-${channel}`;
    return (
      <span className={s.unsubscribed}>
        {dateLabel ? (
          <>
            <span data-tip data-for={tooltipId}>
              {" (Unsubscribed)"}
            </span>
            <ReactTooltip id={tooltipId} type="info" place="top" effect="float">
              {`Since ${dateLabel}`}
            </ReactTooltip>
          </>
        ) : (
          " (Unsubscribed)"
        )}
      </span>
    );
  };

  renderManualUnsubscribeSection = (): JSX.Element => {
    const existingDonor = this.state.existingDonor;
    const contactDeactivated =
      this.state.deactivateDonor || !!existingDonor?.deactivated;
    const isPhoneNumberInvalid =
      (existingDonor &&
        this.state.existingDonor.hasOwnProperty("phoneNumberValid") &&
        this.state.existingDonor.phoneNumberValid === false) ||
      this.state.existingDonor?.phoneNumber?.startsWith("I");
    const isSmsUnsubscribed = existingDonor && existingDonor.smsUnsubscribed;
    const isEmailInvalid =
      existingDonor &&
      this.state.existingDonor.hasOwnProperty("emailValid") &&
      this.state.existingDonor.emailValid === false;
    const isEmailUnsubscribed =
      existingDonor && existingDonor.emailUnsubscribed;

    const masterDisabled =
      contactDeactivated ||
      isSmsUnsubscribed ||
      isEmailUnsubscribed ||
      isEmailInvalid ||
      isPhoneNumberInvalid;

    return (
      <Col
        xs={12}
        md={4}
        sm={6}
        className={classNames(
          contactDeactivated ? s.disabledAll : s.topPadding,
          s.hierarchyColumn
        )}
      >
        <fieldset className={s.hierarchyFieldset}>
          <legend className={s.hierarchyLegend}>Unsubscribe</legend>
          <div className={s.hierarchyPanel}>
            <div
              className={
                masterDisabled ? s.hierarchyMasterDisabled : s.hierarchyMasterRow
              }
            >
              <div className={s.hierarchyMasterInner}>
                <Input
                  type="checkbox"
                  id="allUnsubscribe"
                  checked={this.state.unsubscribeAll}
                  onChange={this.allUnsubscribeChanged}
                  disabled={
                    contactDeactivated ||
                    isSmsUnsubscribed ||
                    isEmailUnsubscribed ||
                    isEmailInvalid ||
                    isPhoneNumberInvalid
                  }
                />
                <label htmlFor="allUnsubscribe" />
                <span className={s.hierarchyMasterLabel}>All</span>
              </div>
            </div>

            <div
              className={
                contactDeactivated ? s.disabledCheck : s.hierarchyOptionRow
              }
            >
              <Input
                type="checkbox"
                id="unbscribeTextCheck"
                checked={this.state.smsUnsubscribed}
                onChange={this.smsUnsubscribedNotificationChanged}
                disabled={contactDeactivated}
              />
              <label htmlFor="unbscribeTextCheck" />
              <span className={contactDeactivated ? s.disabledText : s.label}>
                Text
              </span>
              {this.renderUnsubscribedLabel(
                "sms",
                Boolean(
                  this.state.existingDonor &&
                    this.state.existingDonor.smsUnsubscribed
                )
              )}
            </div>
            <div
              className={
                contactDeactivated ? s.disabledCheck : s.hierarchyOptionRow
              }
            >
              <Input
                type="checkbox"
                id="unsubscribeEmailCheck"
                checked={this.state.emailUnsubscribed}
                onChange={this.emailUnsubscribedNotificationChanged}
                disabled={contactDeactivated}
              />
              <label htmlFor="unsubscribeEmailCheck" />
              <span className={contactDeactivated ? s.disabledText : s.label}>
                Email
              </span>
              {this.renderUnsubscribedLabel(
                "email",
                Boolean(
                  this.state.existingDonor &&
                    this.state.existingDonor.emailUnsubscribed
                )
              )}
            </div>
          </div>
        </fieldset>
      </Col>
    );
  };

  getSegmentsName = () => {
    let names = "";
    this.state.existingDonor.segments.forEach((segment, index) => {
      if (index == this.state.existingDonor.segments.length - 1) {
        names += segment.name;
      } else {
        names += segment.name + ", ";
      }
    });
    return <span className={s.segments}>{names}</span>;
  };

  sleep = ms => {
    return new Promise(resolve => setTimeout(resolve, ms));
  };

  updateComponentFunction = async () => {
    await this.sleep(2000);
    searchDonorByIdExtended(
      this.props.config.searchServiceUrl,
      this.props.currentCharity.id,
      this.props.params.donorId,
      this.props.serviceAccessToken
    ).then(response => {
      if (response) {
        this.setState(
          {
            existingDonor: response,
          },
          () => {
            this.fillDonorValues();
          }
        );
      } else {
        this.props.navigate("/contacts");
      }
    });
  };

  render() {
    const { existingDonor, donorDeactivatedByUser } = this.state;
    const deactivatedDonor = existingDonor && existingDonor.deactivated;
    const isPhoneNumberInvalid =
      (existingDonor &&
        this.state.existingDonor.hasOwnProperty("phoneNumberValid") &&
        this.state.existingDonor.phoneNumberValid === false) ||
      this.state.existingDonor?.phoneNumber?.startsWith("I");
    const isSmsUnsubscribed = existingDonor && existingDonor.smsUnsubscribed;
    const isEmailInvalid =
      existingDonor &&
      this.state.existingDonor.hasOwnProperty("emailValid") &&
      this.state.existingDonor.emailValid === false;
    const isEmailUnsubscribed =
      existingDonor && existingDonor.emailUnsubscribed;

    const isAdmin = isCurrentUserAdmin(this.props.currentCharity);
    const primaryActionDisabled =
      !this.formFirstCheck() || this.state.busyLoading !== null;
    const missingEmailAndPhone =
      (!this.state.fields.email || this.state.fields.email === "") &&
      (!this.state.fields.phoneNumber ||
        this.state.fields.phoneNumber === "");
    const showContactRequirementTooltip =
      isAdmin &&
      primaryActionDisabled &&
      missingEmailAndPhone &&
      this.state.busyLoading === null;

    if (
      deactivatedDonor &&
      existingDonor.deactivatedBy &&
      existingDonor.deactivatedBy !== "auto"
    ) {
      searchUsersById(
        this.props.config.searchServiceUrl,
        this.props.currentCharity.id,
        [existingDonor.deactivatedBy],
        this.props.serviceAccessToken
      ).then(response => {
        if (!isEmpty(response)) {
          this.setState({
            donorDeactivatedByUser:
              response.firstName + " " + response.lastName,
          });
        }
      });
    }

    const showEditContactLoading =
      !!this.props.params.donorId && !this.state.existingDonor;

    return (
      <main className={s.main}>
        <div
          className={classNames(s.container, showEditContactLoading && s.containerBusy)}
          aria-busy={showEditContactLoading ? true : undefined}
        >
          {showEditContactLoading && (
            <div
              className={s.editContactLoadingOverlay}
              role="status"
              aria-live="polite"
            >
              <div className={s.editContactLoadingInner}>
                <i
                  className={classNames(
                    "fa fa-spinner fa-spin",
                    s.editContactLoadingSpinner
                  )}
                  aria-hidden
                />
                <span className={s.editContactLoadingLabel}>Loading contact…</span>
              </div>
            </div>
          )}
          <Row>
            <Col md={{ size: 8, offset: 2 }} sm={12}>
              <h2>
                {this.props.params.donorId ? "Edit Contact" : "New Contact"}
              </h2>
            </Col>
          </Row>
          <Row
            className={classNames(
              s.typeLayoutRow,
              deactivatedDonor && s.typeLayoutRowThreeCols
            )}
          >
            <Col
              md={
                deactivatedDonor
                  ? { size: 3, offset: 2 }
                  : { size: 8, offset: 2 }
              }
              sm={12}
              className={classNames(s.typeRow, s.typeLeadColumn)}
            >
              <div className={s.typeBlock}>
                <span className={s.typeColumnLabel}>Type</span>
                <ButtonGroup className={s.typeButtonGroup}>
                  <Button
                    type="button"
                    color="none"
                    className={classNames(
                      s.typeToggleBtn,
                      !this.state.isCompany && s.typeToggleBtnActive
                    )}
                    onClick={() => {
                      if (!this.state.existingDonor) {
                        this.setState({ isCompany: false });
                      }
                    }}
                    disabled={!!this.state.existingDonor}
                  >
                    Person
                  </Button>
                  <Button
                    type="button"
                    color="none"
                    className={classNames(
                      s.typeToggleBtn,
                      this.state.isCompany && s.typeToggleBtnActive
                    )}
                    onClick={() => {
                      if (!this.state.existingDonor) {
                        this.setState({ isCompany: true });
                      }
                    }}
                    disabled={!!this.state.existingDonor}
                  >
                    Company
                  </Button>
                </ButtonGroup>
              </div>
            </Col>
            {deactivatedDonor && existingDonor && (
              <>
                <Col md={3} sm={12} className={s.typeMetaColumn}>
                  <div className={s.typeMetaStack}>
                    <span className={s.typeColumnLabel}>Deactivated By</span>
                    <span className={s.typeColumnValue}>
                      {donorDeactivatedByUser}
                    </span>
                    {existingDonor.deactivatedComment && (
                      <>
                        <span
                          className={classNames(
                            s.typeColumnLabel,
                            s.typeColumnLabelAfterValue
                          )}
                        >
                          Comment
                        </span>
                        <span className={s.typeColumnValue}>
                          {existingDonor.deactivatedComment}
                        </span>
                      </>
                    )}
                  </div>
                </Col>
                <Col md={4} sm={12} className={s.typeMetaColumn}>
                  <div className={s.typeMetaStack}>
                    <span className={s.typeColumnLabel}>Deactivation Date</span>
                    <span className={s.typeColumnValue}>
                      {existingDonor.deactivatedOn
                        ? getParsedDate(
                            new Date(existingDonor.deactivatedOn).toString(),
                            false,
                            "MM/DD/YYYY, hh:mm a"
                          )
                        : "Not available"}
                    </span>
                  </div>
                </Col>
              </>
            )}
          </Row>
          <br />
          {this.state.isCompany && (
            <Row>
              <Col md={{ size: 4, offset: 2 }} sm={12}>
                <FormGroup>
                  <label className={s.titleLabel} htmlFor="company">
                    Company Name
                  </label>
                  <BaseInput
                    id={"company"}
                    name={"company"}
                    dataElmId={"company"}
                    placeholder=""
                    onChange={this.onValidation("company")}
                    value={this.state.fields.company}
                    errors={this.re.mapFieldErrors("company")}
                    disabled={deactivatedDonor}
                  />
                </FormGroup>
              </Col>
            </Row>
          )}
          <Row>
            <Col md={{ size: 4, offset: 2 }} sm={6}>
              <FormGroup>
                <label className={s.titleLabel} htmlFor="firstName">
                  First Name
                </label>
                <BaseInput
                  id={"firstName"}
                  name={"firstName"}
                  dataElmId={"firstName"}
                  placeholder=""
                  onChange={this.onValidation("firstName")}
                  value={this.state.fields.firstName}
                  errors={this.re.mapFieldErrors("firstName")}
                  disabled={deactivatedDonor}
                />
              </FormGroup>
            </Col>
            <Col md={4} sm={6}>
              <FormGroup>
                <label className={s.titleLabel} htmlFor="lastName">
                  Last Name
                </label>
                <BaseInput
                  id={"lastName"}
                  name={"lastName"}
                  dataElmId={"lastName"}
                  placeholder=""
                  onChange={this.onValidation("lastName")}
                  value={this.state.fields.lastName}
                  errors={this.re.mapFieldErrors("lastName")}
                  disabled={deactivatedDonor}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={{ size: 4, offset: 2 }} sm={6}>
              <FormGroup>
                <label className={s.titleLabel} htmlFor="email">
                  E-mail
                </label>
                <BaseInput
                  id={"email"}
                  name={"email"}
                  dataElmId={"email"}
                  placeholder=""
                  onChange={this.onValidation("email")}
                  value={this.state.fields.email}
                  errors={this.re.mapFieldErrors("email")}
                  disabled={deactivatedDonor}
                />
              </FormGroup>
            </Col>
            <Col md={4} sm={6}>
              <FormGroup>
                <label className={s.titleLabel} htmlFor="phoneNumber">
                  Mobile
                </label>
                <BaseInput
                  id={"phoneNumber"}
                  name={"phoneNumber"}
                  dataElmId={"phoneNumber"}
                  placeholder=""
                  onChange={this.onChangeData("phoneNumber")}
                  value={this.state.fields.phoneNumber}
                  errors={this.re.mapFieldErrors("phoneNumber")}
                  disabled={deactivatedDonor}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={{ size: 4, offset: 2 }} sm={6}>
              <FormGroup>
                <div className={s.labelWithHelp}>
                  <label className={s.titleLabel} htmlFor="accountNumber">
                    Account Number
                  </label>
                  <button
                    type="button"
                    className={s.helpIconButton}
                    data-tip
                    data-for="create-donor-account-tip"
                    aria-label="About account number"
                  >
                    <i className="fa fa-question-circle" />
                  </button>
                  <ReactTooltip id="create-donor-account-tip" effect="solid" place="top">
                    You can use it to easily identify this contact within your registers
                  </ReactTooltip>
                </div>
                <BaseInput
                  id={"accountNumber"}
                  name={"accountNumber"}
                  dataElmId={"accountNumber"}
                  placeholder=""
                  onChange={this.onValidation("accountNumber")}
                  value={this.state.fields.accountNumber}
                  errors={this.re.mapFieldErrors("accountNumber")}
                  disabled={deactivatedDonor}
                />
              </FormGroup>
            </Col>
            {this.props.params.donorId &&
              (isCurrentUserCollaborator(this.props.currentCharity) ||
                (!this.props.currentCharity.disableGive &&
                  !isCurrentUserOnlyCollaborator(
                    this.props.currentCharity
                  ))) && (
                <Col md={4} sm={6}>
                  <div className={s.editShortcutStack}>
                    <div
                      className={s.editShortcutLabelSpacer}
                      aria-hidden
                    />
                    <div className={s.editShortcutButtons}>
                      {isCurrentUserCollaborator(this.props.currentCharity) && (
                        <Button
                          onClick={() => {
                            this.props.toggleSegmentManagerModal(
                              this.props.params.donorId,
                              this.updateComponentFunction
                            );
                          }}
                          className={s.editShortcutButton}
                          id={"SegmentManager"}
                          disabled={
                            deactivatedDonor ||
                            this.state.busyLoading !== null
                          }
                          outline
                          color="secondary"
                        >
                          Segments
                        </Button>
                      )}
                      {!this.props.currentCharity.disableGive &&
                        !isCurrentUserOnlyCollaborator(
                          this.props.currentCharity
                        ) && (
                          <Button
                            className={s.editShortcutButton}
                            data-elem-id={"GivingHistory"}
                            onClick={() =>
                              this.props.navigate(
                                `/donations/${this.props.params.donorId}`
                              )
                            }
                            outline
                            color="secondary"
                          >
                            Giving History
                          </Button>
                        )}
                    </div>
                  </div>
                </Col>
              )}
          </Row>
          {this.state.existingDonor &&
            this.state.existingDonor.segments &&
            this.state.existingDonor.segments.length > 0 && (
              <Row>
                <Col
                  md={{ size: 8, offset: 2 }}
                  sm={12}
                  className={s.colPadding}
                >
                  <label className={s.titleLabel} htmlFor="accountNumber">
                    Segments
                  </label>
                  <br />
                  {this.getSegmentsName()}
                </Col>
              </Row>
            )}
          <Row
            className={
              this.props.params.donorId ? s.hierarchyUnsubscribeRow : undefined
            }
          >
            <Col
              xs={12}
              {...(this.props.params.donorId
                ? { md: { size: 4, offset: 2 }, sm: 6 }
                : { md: { size: 8, offset: 2 } })}
              className={classNames(
                deactivatedDonor ? s.disabledAll : s.topPadding,
                s.hierarchyColumn
              )}
            >
              <fieldset className={s.hierarchyFieldset}>
                <legend className={s.hierarchyLegend}>Hierarchy</legend>
                <div className={s.hierarchyPanel}>
                  <div
                    className={
                      deactivatedDonor ||
                      isPhoneNumberInvalid ||
                      isEmailInvalid ||
                      isSmsUnsubscribed ||
                      isEmailUnsubscribed
                        ? s.hierarchyMasterDisabled
                        : s.hierarchyMasterRow
                    }
                  >
                    <div className={s.hierarchyMasterInner}>
                      <Input
                        type="checkbox"
                        id="allNotifications"
                        checked={this.state.allNotifications}
                        onChange={this.allNotificationsChanged}
                        disabled={
                          deactivatedDonor ||
                          isPhoneNumberInvalid ||
                          isEmailInvalid ||
                          isSmsUnsubscribed ||
                          isEmailUnsubscribed
                        }
                      />
                      <label htmlFor="allNotifications" />
                      <span className={s.hierarchyMasterLabel}>All</span>
                    </div>
                  </div>

                  <div
                    className={
                      deactivatedDonor ||
                      isPhoneNumberInvalid ||
                      isSmsUnsubscribed
                        ? s.disabledCheck
                        : s.hierarchyOptionRow
                    }
                  >
                    <Input
                      type="checkbox"
                      id="smsCheck"
                      checked={this.state.smsNotification}
                      onChange={this.smsNotificationChanged}
                      disabled={
                        deactivatedDonor ||
                        isPhoneNumberInvalid ||
                        isSmsUnsubscribed
                      }
                    />
                    <label htmlFor="smsCheck" />
                    <span
                      className={
                        deactivatedDonor ||
                        isPhoneNumberInvalid ||
                        isSmsUnsubscribed
                          ? s.disabledText
                          : s.label
                      }
                    >
                      Text
                    </span>
                    <span className={s.unsubscribed}>
                      {this.state.existingDonor && isPhoneNumberInvalid
                        ? " (Invalid Phone Number)"
                        : ""}
                    </span>
                  </div>

                  <div
                    className={
                      deactivatedDonor || isEmailInvalid || isEmailUnsubscribed
                        ? s.disabledCheck
                        : s.hierarchyOptionRow
                    }
                  >
                    <Input
                      type="checkbox"
                      id="emailCheck"
                      checked={this.state.emailNotification}
                      onChange={this.emailNotificationChanged}
                      disabled={
                        deactivatedDonor || isEmailInvalid || isEmailUnsubscribed
                      }
                    />
                    <label htmlFor="emailCheck" />
                    <span
                      className={
                        deactivatedDonor || isEmailInvalid || isEmailUnsubscribed
                          ? s.disabledText
                          : s.label
                      }
                    >
                      Email
                    </span>
                    <span className={s.unsubscribed}>
                      {this.state.existingDonor && isEmailInvalid
                        ? " (Invalid Email)"
                        : ""}
                    </span>
                  </div>
                </div>
              </fieldset>
            </Col>
            {this.props.params.donorId && this.renderManualUnsubscribeSection()}
          </Row>

          <br />
          <Row>
            <Col sm={12} md={{ size: 8, offset: 2 }} className={s.formToolbarCol}>
              <div className={s.formToolbarBar}>
                <div className={s.formToolbarCancelWrap}>
                  <Button
                    id={"CancelBackButton"}
                    onClick={() => this.props.navigate("/contacts")}
                    className={s.formToolbarCancel}
                    color="link"
                    disabled={this.state.busyLoading !== null}
                  >
                    {isAdmin ? "Cancel" : "Back"}
                  </Button>
                </div>
                {isAdmin && (
                  <div className={s.formToolbarActionGroup}>
                    {this.props.params.donorId && existingDonor && (
                      <>
                        {existingDonor.deactivated ? (
                          <Button
                            type="button"
                            color="primary"
                            className={s.formToolbarPrimary}
                            id="DeactivateContactToolbar"
                            disabled={this.state.busyLoading !== null}
                            onClick={() =>
                              this.setState({ deactivateDonorModalOpen: true })
                            }
                          >
                            {this.state.busyLoading === "deactivate" ? (
                              <i className="fa fa-spinner fa-spin">&nbsp;</i>
                            ) : (
                              "Activate"
                            )}
                          </Button>
                        ) : (
                          <Button
                            type="button"
                            outline
                            color="secondary"
                            className={s.formToolbarSecondary}
                            id="DeactivateContactToolbar"
                            disabled={this.state.busyLoading !== null}
                            onClick={() =>
                              this.setState({ deactivateDonorModalOpen: true })
                            }
                          >
                            Deactivate
                          </Button>
                        )}
                      </>
                    )}
                    {!(
                      this.props.params.donorId && existingDonor?.deactivated
                    ) &&
                      (showContactRequirementTooltip ? (
                        <span
                          data-tip
                          data-for="create-donor-contact-required-tip"
                          className={s.formPrimaryWrap}
                        >
                          <Button
                            onClick={() => {
                              if (this.props.params.donorId) {
                                this.confirmUpdateDonor();
                              } else {
                                this.createEditDonor(true);
                              }
                            }}
                            className={s.formToolbarPrimary}
                            color="primary"
                            id={"UpdateCreateButton"}
                            disabled={primaryActionDisabled}
                          >
                            {this.state.busyLoading === "save" ? (
                              <i className="fa fa-spinner fa-spin">&nbsp;</i>
                            ) : this.props.params.donorId ? (
                              "Update"
                            ) : (
                              "Create"
                            )}
                          </Button>
                          <ReactTooltip
                            id="create-donor-contact-required-tip"
                            effect="solid"
                            place="top"
                          >
                            Contact must have either an Email or a Mobile phone
                            associated.
                          </ReactTooltip>
                        </span>
                      ) : (
                        <Button
                          onClick={() => {
                            if (this.props.params.donorId) {
                              this.confirmUpdateDonor();
                            } else {
                              this.createEditDonor(true);
                            }
                          }}
                          className={s.formToolbarPrimary}
                          color="primary"
                          id={"UpdateCreateButton"}
                          disabled={primaryActionDisabled}
                        >
                          {this.state.busyLoading === "save" ? (
                            <i className="fa fa-spinner fa-spin">&nbsp;</i>
                          ) : this.props.params.donorId ? (
                            "Update"
                          ) : (
                            "Create"
                          )}
                        </Button>
                      ))}
                  </div>
                )}
              </div>
            </Col>
          </Row>

          {this.renderDeactivatedModal()}
        </div>
      </main>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  hideSelection: () => {
    dispatch(commonActions.hideSelection());
  },
  refreshDashboard: () => {
    dispatch(commonActions.refreshDashboard());
  },
});

export default serviceCaller(
  withLoginRedirect(
    connect(
      null,
      mapDispatchToProps
    )(withModals(withStyles(s)(CreateDonor)))
  )
);
